<template>
  <div>
    <page-header title="ساخت مدیر"></page-header>

    <crud-generator :fields="fields" @submit="submit" name="admins"></crud-generator>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";

export default {
  name: "CreateAdmin",

  components: {CrudGenerator, PageHeader},

  data() {
    return {
      fields: [],
    }
  },

  mounted() {
    this.fillFields()
  },

  methods: {
    fillFields() {
      this.fields = [
        {
          name: 'name',
          label: 'نام',
          cols: 4,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'email',
          label: 'ایمیل',
          cols: 4,
          type: 'text',
          direction: 'ltr',
        },
        {
          name: 'password',
          label: 'رمز عبور',
          cols: 4,
          type: 'text',
          direction: 'ltr'
        },
      ]
    },

    submit(values) {
      this.$store.dispatch("createAdmin", values)
          .then(() => {
            this.$router.push('/admins')
          })
    }
  }
}
</script>

<style scoped>

</style>